module.exports = __webpack_public_path__ + "static/media/time-spent.d077a0f1.png";